import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image } from 'antd';
import { getApiUrl } from '@/shared/utils';
export const FreeEmptyImage = ({ message, imageProps, }) => {
    return (_jsxs("div", { style: { textAlign: 'center' }, children: [_jsx(Image, { preview: false, height: 200, src: `${getApiUrl()}/public/empty_data_pic.png`, ...imageProps }), _jsx("div", { style: {
                    lineHeight: '22px',
                    color: 'rgba(0,0,0,0.45)',
                    fontSize: '14px',
                }, children: message ?? '暂无数据' })] }));
};
